<!-- <app-icon name="spinner" type="solid" [size]="size" /> -->
<span class="material-symbols-rounded spinner rotating" aria-hidden="true"> progress_activity </span>
